module.exports = __webpack_public_path__ + "static/media/manThinking.699fbe8e.png";